import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ITenantEmployee } from 'app/shared/model/tenant-employee.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { BillFor } from 'app/shared/model/enumerations/bill-for.model';

export interface IPharmacyRefundBill {
  id?: string;
  billNumber?: string | null;
  billDate?: number | null;
  refundAmount?: number | null;
  totalCost?: number | null;
  discount?: number | null;
  active?: boolean | null;
  cursor?: number | null;
  timestampentry?: number | null;
  microSec?: number | null;
  lastupdated?: number | null;
  cgst?: number | null;
  sgst?: number | null;
  patientType?: keyof typeof PatientType | null;
  printed?: boolean | null;
  printCount?: number | null;
  voided?: boolean | null;
  voidedReason?: string | null;
  voidedDate?: number | null;
  roundOffVal?: number | null;
  billFor?: keyof typeof BillFor | null;
  billForId?: string | null;
  status?: string | null;
  pharmacy?: IPharmacy | null;
  glucoUser?: IGlucoUser | null;
  pharmacist?: ITenantEmployee | null;
  saleBill?: IPharmacyBill | null;
  returnBill?: IPharmacyReturnBill | null;
  admission?: IAdmission | null;
  consumer?: IPharmacy | null;
}

export const defaultValue: Readonly<IPharmacyRefundBill> = {
  active: false,
  printed: false,
  voided: false,
};
